import { createStyles } from '@mantine/styles';
var useStyles = createStyles(function () {
  return {
    input: {
      "&:not(:disabled)": {
        cursor: "pointer",
        "&::selection": {
          backgroundColor: "transparent"
        }
      }
    }
  };
});
export default useStyles;